import * as actionTypes from "../actionTypes";

const initialState = {
  theme: "",
  taskLayout: "",
  persistIn: "local"
};

export default function appSettingsReducer(state = initialState, action) {
  let data = action.data;
  switch (action.type) {
    case actionTypes.SET_THEME:
      return {
        ...state,
        theme: data
      };
    case actionTypes.SET_TASKLAYOUT:
      return {
        ...state,
        taskLayout: data
      };
    default:
      return state;
  }
}
